export const environment = {
  production: true,
  baseUrl: 'https://msa.stg02-dev.int.nettask.de/hxa-sparo',
  appVersion: require('../../package.json').version + '-stage2',
  unleash: {
    enabled: false,
    url: '',
    clientKey: '',
    appName: '',
  },
};
